export var BankAbbreviations;
(function (BankAbbreviations) {
    BankAbbreviations["TB"] = "TBCBGE22";
    BankAbbreviations["BG"] = "BAGAGE22";
    BankAbbreviations["CD"] = "JSCRGE22";
    BankAbbreviations["IS"] = "ISBKGE22";
    BankAbbreviations["PB"] = "PAHAGE22";
    BankAbbreviations["HB"] = "HABGGE22";
    BankAbbreviations["KS"] = "TEBAGE22";
    BankAbbreviations["BT"] = "DISNGE22";
    BankAbbreviations["PC"] = "MIBGGE22";
    BankAbbreviations["ZB"] = "TCZBGE22";
    BankAbbreviations["CR"] = "CRTUGE22";
    BankAbbreviations["BS"] = "CBASGE22";
    BankAbbreviations["LB"] = "LBRTGE22";
})(BankAbbreviations || (BankAbbreviations = {}));
//# sourceMappingURL=bank-abbreviation.enum.js.map